var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfCb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12677 -0.00488281C8.45125 -0.00488281 8.76995 0.126878 8.99972 0.356645L11.4003 2.75724C11.6334 2.99029 11.7618 3.30076 11.7618 3.63017V13.9951H0.232422V-0.00488281H8.12677ZM7.64419 0.818645H1.05594V13.1716H10.9383V4.11277H7.64418V0.818638L7.64419 0.818645ZM8.46771 0.989117V3.28924H10.7678L8.46771 0.989117Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5666 4.93555C5.76177 4.93555 5.93389 5.02779 6.06237 5.21143C6.36789 5.64213 6.34649 6.10084 6.23366 6.71848C6.19496 6.93096 6.23449 7.1459 6.35225 7.3246C6.5186 7.57825 6.75825 7.92743 6.99377 8.22307C7.16672 8.44131 7.43272 8.55743 7.70201 8.52119C7.87496 8.49731 8.08331 8.47755 8.29742 8.47755C9.25272 8.47755 9.18107 8.81848 9.26754 9.13143C9.3153 9.32084 9.29142 9.48637 9.19342 9.60907C9.07154 9.7746 8.82036 9.86025 8.45307 9.86025C8.04625 9.86025 7.91201 9.79108 7.55789 9.67825C7.35777 9.61401 7.15025 9.60084 6.94765 9.65437C6.54331 9.75978 5.87625 9.92037 5.31954 9.99696C5.02225 10.0381 4.75213 10.1913 4.5726 10.4408C4.16825 11.0008 3.79354 11.5238 3.19978 11.5238C3.0466 11.5238 2.90578 11.4686 2.78966 11.3583C2.61837 11.187 2.54507 10.9967 2.58131 10.776C2.68178 10.0983 3.51519 9.72025 4.01096 9.44437C4.12789 9.37931 4.22013 9.27966 4.27778 9.15613L5.06425 7.45555C5.12025 7.33613 5.13754 7.20355 5.11696 7.0726C5.02554 6.49613 4.89048 5.52684 5.25366 5.08872C5.33354 4.99072 5.4439 4.93555 5.5666 4.93555ZM5.71649 7.41437C5.40107 8.33755 4.84354 9.34143 4.7686 9.45837C5.44142 9.14213 6.78049 8.98237 6.78049 8.98237C6.10684 8.33343 5.71649 7.41437 5.71649 7.41437Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfCb);
export default __webpack_public_path__ + "static/media/pdf-cb.07ba1e8f258448dc9d38945c4e18336d.svg";
export { ForwardRef as ReactComponent };